import Wrapper from '@/common/wrapper/Wrapper';
import style from '../style/ExamList.module.less';
import { Divider, Switch, DatePicker } from 'antd';
import IconFont from '@/common/IconFont';
import { courseRecord } from '@/utils/const';
import Icon from '@/common/Icon';
import { useMemo, useState } from 'react';
import { useUserInfo } from '@hooks/hooks';
import ExamItemHeader from '@pages/front/pages/examCenter/components/ExamItemHeader';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { getExamCourseList } from '@/service/exam/list';
import { useEffect } from 'react';
import Modal from '@/common/modal/Modal';
import moment, { Moment } from 'moment';
import { ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import {hasPermission} from '@/utils';

interface ExamItemProps extends Exam {
  toExamAdd:(prop: Exam) => void;
  deleteFn:(prop: Exam) => void;
  toImportScorePage: (prop: ExamCours) => void;
  toAnalysisPage: () => void;
  toReportSettingPage: () => void;
  toAbsence:(prop:Exam) => void;
  toModifyScorePage:(prop: Exam) => void;
  toPublish:(prop: Exam) => void;
  index: number;
  onArchive: (prop: Exam) => void;
  toSchoolImportedPage: (prop: Exam) => void;
  canSchoolImportChange: (prop: SwitchSchoolImportParams) => void;
}

const ExamItem: React.FC<ExamItemProps> = props => {

  const [show, setShow] = useState(false);
  const userState = useUserInfo();
  const isEduUser = useMemo(() => userState.userType === 'EDU', [userState]);
  const [examCourseList, setExamCourseList] = useState<ExamCours[]>([]);
  const [loading, setLoading] = useState(false);
  const [showSetTimeModal, setShowSetTimeModal] = useState(false);
  const [schoolImportTime, setSchoolImportTime] = useState<Moment | null>(null);
  const archive = props.archive; // 是不是已经归档

  const loadExamCourse = async () => {
    if (examCourseList.length > 0) {
      setShow(!show);
      return false;
    }
    if (!show && examCourseList.length === 0) {
      try {
        setLoading(true);
        const { data } = await getExamCourseList(props.id);
        setExamCourseList(data instanceof Array ? data : []);
      } finally {
        setLoading(false);
      }
    }
    setShow(!show);
  };

  const init = async () => {
    const { data } = await getExamCourseList(props.id);
    setExamCourseList(data instanceof Array ? data : []);
    setShow(true);
  };

  const saveSchoolImportTime = () => {
    setShowSetTimeModal(false);
    props.canSchoolImportChange && props.canSchoolImportChange({
      isOpen: props.canSchoolImport,
      examId: props.id,
      endTime: schoolImportTime ? schoolImportTime.valueOf() : ''
    });
  };

  const canSchoolImportChange = (checked: boolean) => {
    props.canSchoolImportChange && props.canSchoolImportChange({
      isOpen: checked,
      examId: props.id,
      endTime: props.schoolImportEndTime || ''
    });
  };

  const ifCanImportScore = (course: ExamCours) => {
    if (isEduUser) return true;
    if (props.canSchoolImport) {
      if (!course.fullScore) return false;
      if (!props.schoolImportEndTime) return true;
      const currentDate = Date.now().valueOf();
      return currentDate <= props.schoolImportEndTime;
    }
  };

  useEffect(() => {
    props.index === 0 && init();
  }, []);

  useEffect(() => {
    show && (async () => {
      const { data } = await getExamCourseList(props.id);
      setExamCourseList(data instanceof Array ? data : []);
    })();
  }, [props]);

  useEffect(() => {
    if (props.schoolImportEndTime) {
      setSchoolImportTime(moment(props.schoolImportEndTime));
    } else {
      setSchoolImportTime(null);
    }
  }, [props.schoolImportEndTime]);
  return (
    <Wrapper className={style.examWrapper}>
      <ExamItemHeader {...props} hideBtn={userState.userType === 'TEACHER'}/>
      <div className={style.grades}>
        <div>
          <div>
            {props.examCoursetypeDcodes.map(i => courseRecord[i]).join(' · ')}
          </div>
          <div>
            {/* 学校导入开关/ */}
            {
              isEduUser && !archive && hasPermission('EXAM:IMPORT_SCORE') && (
                <span className={style.schoolImportSwitchWrapper}>
                  <span className="grey">学校导入开关</span>
                  <Switch
                    checkedChildren="开启"
                    unCheckedChildren="关闭"
                    checked={props.canSchoolImport}
                    onChange={canSchoolImportChange}
                  />
                  {
                    props.canSchoolImport && !props.schoolImportEndTime && <span className={style.setEndTime} onClick={() => setShowSetTimeModal(true)}>
                      <ClockCircleOutlined />
                      设置时间
                    </span>
                  }
                  {
                    props.canSchoolImport && props.schoolImportEndTime && <span className={style.setEndTime} onClick={() => setShowSetTimeModal(true)}>
                      <span className="grey">截止：</span>
                      { dayjs(props.schoolImportEndTime).format('YYYY-MM-DD HH:mm') }
                      <IconFont type="icon-xiugai" />
                    </span>
                  }
                </span>
              )
            }
            {
              isEduUser && hasPermission('EXAM:IMPORT_SCORE') && (<Icon
                style={{marginRight: '10px'}}
                type='icon-gailan'
                onClick={() => props.toSchoolImportedPage(props)}
              >
                各校导入概览
              </Icon>)
            }
            {
              loading && <Loading3QuartersOutlined spin className={style.loadingIcon} />
            }
            <span onClick={loadExamCourse}>{show ? '收起' : '展开'}</span>
            <IconFont type="icon-zhankai" className={show ? style.show : style.hide} />
          </div>
        </div>
        <div
          className={show ? style.show : style.hide}
          style={{height: `${examCourseList.length * 50}px`}}
        >
          {
            examCourseList.map(i => (
              <div key={i.id}>
                <div>
                  <span>【{courseRecord[i.coursetypeDcode]}】</span>
                  <Divider type="vertical" />
                  <span className="grey">{typeof i.fullScore === 'number' ? i.fullScore : '-'}分</span>
                  <Divider type="vertical" />
                  <span className="grey">实考/缺考/全部：</span>
                  {
                    i.hasScore && props.hasGenerateReport ?
                      <span>{i.stuPresentCount}/{i.stuAbsentCount}/{i.stuTotalCount}</span> :
                      <span>-/-/{props.stuTotalCount}</span>
                  }
                </div>
                {
                  ifCanImportScore(i) && hasPermission('EXAM:IMPORT_SCORE') && (
                    <div onClick={() => props.toImportScorePage(i)}>
                      <Icon type="daoruchengji">导入成绩</Icon>
                    </div>
                  )
                }
              </div>
            ))
          }
        </div>
      </div>
      <div className={style.btns}>
        {
          hasPermission('EXAM:ABSENT_MARK') && (
            <>
              <div onClick={() => props.toAbsence(props)}>
                <Icon type="quekaomingdanshenhe">
                      缺考/标记学生名单(<span
                    className="red">{!props.hasGetAbsent ? '未获取' : props.markStudentCount}</span>)
                </Icon>
              </div>
              <Divider type="vertical"/>
            </>
          )
        }
        {
          isEduUser && (
            <>
              {
                hasPermission('EXAM:REPORT_CONFIG') && (
                  <>
                    <div>
                      <Icon type="icon-shezhi" onClick={props.toReportSettingPage}>
                            报告设置
                      </Icon>
                    </div>
                    <Divider type="vertical"/>
                  </>
                )
              }
              {
                hasPermission('EXAM:MODIFY_SCORE') && (
                  <>
                    <div>
                      <Icon type="icon-xiugai" onClick={() => props.toModifyScorePage(props)}>
                            修改成绩
                      </Icon>
                    </div>
                    <Divider type="vertical"/>
                  </>
                )
              }
            </>
          )
        }
        {
          hasPermission('EXAM:VIEW_REPORT') &&
            (
              <div
                title={!isEduUser && !props.existPublishConfig ? '本场考试暂未发布' : ''}
              >
                {/* <span>查看分析</span> */}
                <Icon
                  type="icon-chakanfenxi"
                  onClick={props.toAnalysisPage}
                  disabled={
                    !props.existPublishConfig ||
                          props.stuPresentCount === 0 ||
                          !props.hasGenerateReport
                  }
                >
                    查看分析
                </Icon>
              </div>
            )
        }
        {
          isEduUser && (
            <>
              {
                hasPermission('EXAM:PUBLISH_CONFIG') && (
                  <>
                    <Divider type="vertical"/>
                    <div>
                      <Icon type="icon-fabu" onClick={() => props.toPublish(props)}>
                          发布设置
                      </Icon>
                    </div>
                  </>
                )
              }
              {
                hasPermission('EXAM:ARCHIVE') && (
                  <>
                    <Divider type="vertical"/>
                    <div>
                      <Icon type="guidang" disabled={archive} onClick={() => props.onArchive(props)}>
                          归档
                      </Icon>
                    </div>
                  </>
                )
              }
            </>
          )
        }
      </div>
      <Modal
        visible={showSetTimeModal}
        title="设置时间"
        onCancel={() => setShowSetTimeModal(false)}
        onOk={saveSchoolImportTime}
      >
        <span>截止时间：</span>
        <DatePicker
          showTime
          value={schoolImportTime}
          style={{ width: '200px' }}
          onChange={date => setSchoolImportTime(date)}
        />
      </Modal>
    </Wrapper>
  );
};

export default ExamItem;
